import React from 'react'
import { useNavigate } from 'react-router-dom'
import OdulOneriBasvuruFormu from './OdulOneriBasvuruFormu'
import './OdulOneriBasvuruFormu.css'

/** /odul-oneri/basvuru — HTML 1 prototip: koyu zemin + beyaz kart */
const OdulOneriBasvuruPage = () => {
  const navigate = useNavigate()

  return (
    <div className="odul-basvuru-shell">
      <OdulOneriBasvuruFormu handleClose={() => navigate('/')} />
    </div>
  )
}

export default OdulOneriBasvuruPage
